module.exports = __webpack_public_path__ + "static/img/sourceBanner2.f7a3aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/source/sourceBanner2.png
// module id = QYSW
// module chunks = 0